import { PromotionLabels } from 'libs/shared-lib/interfaces/partner-web/promotion';
import { m030c195CtaImageTeasers, m070c040DealerContact, vehicleCardLabels } from '../../shared/shared.fr';

export const PROMOTION_LABELS_FR: PromotionLabels = {
    list: {
        headline: 'Actions actuelles',
        showMore: 'Afficher plus',
    },
    detail: {
        m070c040DealerContact,
        m030c195CtaImageTeasers,
        at: 'Chez',
        in: 'à',
        and: 'et',
        region: 'dans la région',
        andLocation: 'ainsi que sur notre site à',
        andLocations: 'ainsi que sur nos sites à',
        vehicleCardLabels: vehicleCardLabels,
        vehicleListMoreButtonLabel: 'Afficher plus',
    },
};
